import { lazy } from "react";

const Login = lazy(() => import("../Component/Login/Login"));
const ForgotMobile = lazy(() => import("../Component/Login/ForgotMobile"));
const ResetPassword = lazy(() => import("../Component/ForgotPassword/ResetPassword"));
const ChangePassword = lazy(() => import("../Component/ForgotPassword/ChangePassword"));
const ChangePhoneNo = lazy(() => import("../Component/ForgotPassword/ChangePhoneNo"));
const ChangeEmail = lazy(() => import("../Component/ForgotPassword/ChangeEmail"));

const authRoutes = [
  { path: "/", element: <Login />, protected: false },
  { path: "/forgot-password", element: <ForgotMobile />, protected: false },
  { path: "/reset-password", element: <ResetPassword />, protected: false },
  { path: "/change-password", element: <ChangePassword />, protected: true },
  { path: "/change-phone-no", element: <ChangePhoneNo />, protected: true },
  { path: "/change-email", element: <ChangeEmail />, protected: true },
];

export default authRoutes;
